// import { updateBarcodeBadge } from "app/actions/userActions";
import { Field, Form, Formik } from "formik";
import ReactModal from "react-modal";

import { QRAuthToken } from "pwapi";

import { updateBarcodeBadge } from "app/actions/userActions";
import { useAppDispatch } from "app/hooks";

const EditPINModal = ({
  editPIN,
  setEditPIN,
}: {
  editPIN: QRAuthToken | undefined;
  setEditPIN: React.Dispatch<React.SetStateAction<QRAuthToken | undefined>>;
}) => {
  const dispatch = useAppDispatch();

  return (
    <ReactModal
      isOpen={!!editPIN}
      onRequestClose={() => {
        setEditPIN(undefined);
      }}
      contentLabel="Edit Badge PIN"
      className="Modal"
      overlayClassName="Overlay"
    >
      <Formik
        initialValues={{ id: editPIN?.id || 0, pin: "" }}
        onSubmit={(values) => {
          console.log(values);
          values.pin &&
            dispatch(
              updateBarcodeBadge({
                id: values.id || 0,
                requestBody: { pin: values.pin },
              })
            );
          setEditPIN(undefined);
        }}
      >
        <Form autoComplete="off">
          <div className="BarcodeLogin BarcodeLogin--reset">
            <Field
              className="BarcodeLogin__number"
              type="password"
              name="pin"
              maxLength={4}
              size={4}
              autoComplete="off"
              autoFocus={true}
            />
            <button type="submit">Reset PIN</button>
          </div>
        </Form>
      </Formik>
    </ReactModal>
  );
};

export default EditPINModal;
